// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"bf2db629","406":"897cd576","445":"6563334e","455":"1513f472","720":"807548aa"}[chunkId] + ".chunk.js";
};